<template>
	<div>
		<div class="header" style="background-color: rgb(246, 246, 246);display: flex;justify-content: space-between;">
			<div style="display: flex;align-items: center;">
				<img src="../../assets/images/indexIcon.png" alt="">
				<p><span>首页-解决方案池</span>-创建解决求助</p>
			</div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<div style="display: flex;justify-content: space-between;">
			
			<div class="left">
				
				<div style="background:#E5EDFB;">
					<div
						style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;padding:0 15px;">
						解决方案求助
					</div>
				</div>
				<div style="display: flex;justify-content: center;margin: 30px;">
					<div :class="['box-f',arrowStep == 1?'box-active':'']">解决方案求助</div>
					<div :class="['box',arrowStep == 2?'box-active':'']">设置交易喜好</div>
					<div :class="['box-l',arrowStep == 3?'box-active':'']">网站审核/公布</div>
				</div>
				<div class="form-one" v-if="nowWeAre == 1">

					<div class="form-item">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								<span style="color: red;">*</span> 资源标题：
							</div>
							<div class="inpt">
								<el-input style="width: 100%;height: 100%;" v-model="serveData.title" type="text"
									placeholder="请输入内容" maxlength="80" show-word-limit></el-input>
							</div>
						</div>
					</div>
					<div class="form-item">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								<span style="color: red;">*</span>资源分类：
							</div>
							<div style=" display: flex;">
								<div style="margin-right: 25px;">
									<el-select v-model="xueKeValue" @change="chooseFl" placeholder="请选择学科">
										<el-option v-for="item in xueKeOptions" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
								<div style="margin-right: 25px;">
									<el-select v-model="hangYeValue" @change="chooseHY" placeholder="请选择行业">
										<el-option v-for="item in hangYeOptions" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
								<div style="margin-right: 25px;">
									<el-select v-model="jieDuanValue" @change="chooseJD" placeholder="请选择阶段">
										<el-option v-for="item in jieDuanOptions" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
							</div>
						</div>
					</div>
					<div class="form-item">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								<span style="color: red;">*</span>添加缩略图：
							</div>
							<el-upload :on-success='uploadSLT' class="upload-demo" accept=".png,.jpeg" :show-file-list='false'
								:headers='{token:$store.state.userInfo.token}' :action="uploadPath+'common/upload'" multiple
								:file-list="fileList1">
								<div
									style="width: 230px;height: 44px;border: 1px solid #D2D2D2;text-align: center;line-height: 44px;cursor: pointer; margin-right:25px;background: #f6f6f6;">
									点击上传</div>
							</el-upload>
							<div v-if="serveData.image">
								<img :src='getImgSrc(serveData.image)' alt="" style="width: 100px;height: 100px;margin-right: 25px;">
							</div>
							<!-- 	<div
								style="">
								选择系统图标</div> -->
							<el-popover placement="bottom" title="选择图标" width="510" trigger="click">
								<div style="display: flex;flex-wrap: wrap;">
									<div v-for="(item,index) in imageList" :key="item.id"
										:class="['tubiao',item.image == serveData.image ? 'activeImg':'']"
										@click="chooseImage(item)">
										<img :src="getImgSrc(item.image)" alt="">
									</div>
								</div>
								<el-button
									style=" border-radius: 0;
									width: 230px;height: 46px;border: 1px solid #D2D2D2;text-align: center;cursor: pointer; margin-right:25px;color: black;font-size: 16px"
									slot="reference">
									选择系统图标</el-button>
							</el-popover>
							<input type="checkbox" style="color: ;background-color: #0052D9;" @change="autoImage"
								v-model="autoGetImage">自动分配
						</div>
					</div>
					<div class="form-item" v-if="zyTemplate.length">
						<div style="display: flex;justify-content: space-between;width: 100%;">
							<div class="jtitle">
							<span style="color: red;">*</span>	问题摘要描述：
							</div>
							
						</div>
						<div class="laterUp">
						</div>
						<div style="width:90%;margin-left: 140px;margin-top: 20px;">
							<div class="item-content">
								<div class="muban" @click="$router.push(`/kongEditor?index=${0}`)">
									<div>
										<img src='../../assets/images/muban.png' alt="">
										<p>从空白模板创建</p>
									</div>
								</div>
								<div class="muban" v-if='$store.state.releaseInfo[0].id'
									@click="$router.push(`/histroyEditor?index=${0}`)">
									<div>
										<img src='../../assets/images/muban.png' alt="">
										<p>从上次修改创建</p>
									</div>
								</div>
								<div class="muban" v-for="(item,index) in zyTemplate" :key="item.id"
									@click="toMbDetail(item.id,0)">
									<div class="m1">
										<img src='../../assets/images/muban.png' alt="">
										<p class="m2">{{item.name}}</p>
									</div>
								</div>
							
							</div>
						</div>
					</div>
					<div class="form-item">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								<span style="color: red;"></span> 问题摘要显示：
							</div>
							<div @click="$router.push(`/editorbanben1?index=${serveData.summary}`)" v-if="serveData.summary" class="rich-text-content" v-html="renderedMarkdown1"></div>
						</div>
						<div v-if="serveData.summary" class="bottom" style="margin-top: 0px;">
							<span
							  style="display:inline-block;margin-left: 30px; color: #0052D9;margin-top: 0px;" 
							  @click="$router.push(`/editorbanben1?index=${serveData.summary}`)"
							>
							  查看
							</span>
						      <span v-if="serveData.summary"
						        style="display:inline-block;margin-left: 30px; color: #0052D9;margin-top: 0px;" 
						        @click="$router.push(`/editorbanben?index=${serveData.summary}`)"
						      >
						        编辑
						      </span>
						      
						      <span 
							    v-if="serveData.summary"
						        class="delitem" 
						        style="display:inline-block;margin-left: 30px;color: red;margin-top: 0px;" 
						        @click="deleteDrafts(1,serveData.summary,'a1')"
						      >
						        删除
						      </span>
						</div>
					</div>
					<div class="form-item">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								<span style="color: red;">*</span>关键词：
							</div>
							<div class="inpt" style="height: 32px;">
								<el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
									@close="handleClose(tag)">
									{{tag}}
								</el-tag>
								<el-input class="input-new-tag" v-if="inputVisible" id="taginp" v-model="inputValue"
									ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
									@blur="handleInputConfirm">
								</el-input>
								<el-button v-else class="button-new-tag" size="small" @click="showInput">+ New
									Tag</el-button>
							</div>
						</div>
					</div>
					<div class="form-item" v-if="slTemplate.length">
						<div style="display: flex;justify-content: space-between;width: 100%;">
							<div class="jtitle">
								问题详情描述：
							</div>
							<div style="display: flex;align-items: center;"><input
									:disabled="!$store.state.releaseInfo[1].id" type="checkbox"
									style="color: ;background-color: #0052D9;">暂不上传，有意向后上传</div>
						</div>
						<div class="laterUp">
						</div>
						<div style="width:90%;margin-left: 140px;margin-top: 20px;">
							<div class="item-content">
								<div class="muban" @click="$router.push(`/kongEditor?index=${1}`)">
									<div>
										<img src='../../assets/images/muban.png' alt="">
										<p>从空白模板创建</p>
									</div>
								</div>
								<div class="muban" v-if='$store.state.releaseInfo[1].id'
									@click="$router.push(`/histroyEditor?index=${1}`)">
									<div>
										<img src='../../assets/images/muban.png' alt="">
										<p>从上次修改创建</p>
									</div>
								</div>
								<div class="muban" v-for="(item,index) in slTemplate" :key="item.id"
									@click="toMbDetail(item.id,1)">
									<div class="m1">
										<img src='../../assets/images/muban.png' alt="">
										<p class="m2">{{item.name}}</p>
									</div>
								</div>
		
							</div>
						</div>
					</div>
					<div class="form-item">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								<span style="color: red;"></span> 问题详情显示：
							</div>
							<div @click="$router.push(`/editorbanben1?index=${serveData.content}`)" v-if="serveData.content" class="rich-text-content" v-html="renderedMarkdown2"></div>
						</div>
						<div v-if="serveData.content" class="bottom" style="margin-top: 0px;">
							<span
							  style="display:inline-block;margin-left: 30px; color: #0052D9;margin-top: 0px;" 
							  @click="$router.push(`/editorbanben1?index=${serveData.content}`)"
							>
							  查看
							</span>
						      <span v-if="serveData.content"
						        style="display:inline-block;margin-left: 30px; color: #0052D9;margin-top: 0px;" 
						        @click="$router.push(`/editorbanben?index=${serveData.content}`)"
						      >
						        编辑
						      </span>
						      
						      <span 
							    v-if="serveData.content"
						        class="delitem" 
						        style="display:inline-block;margin-left: 30px;color: red;margin-top: 0px;" 
						        @click="deleteDrafts(1,serveData.content,'a2')"
						      >
						        删除
						      </span>
						</div>
					</div>
					<!-- 				<div class="form-item" style="align-items: flex-start;">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								访问权限设置：
							</div>
		
							<div></div>
						</div>
						<div>
							<el-radio-group v-model="radio" @input='chooseQx'>
								<div style="margin: 30px 0;"> <el-radio :label="3">完全公开</el-radio></div>
		
								<div style="margin: 30px 0;"> <el-radio :label="9">用户应助，我同意</el-radio></div>
								<div style="margin: 30px 0;width: 500px;"> <el-radio :label="6">对以下用户公开</el-radio>
								</div>
		
							</el-radio-group>
							<el-transfer v-model="valuedw" :data="datadw"></el-transfer>
							<div style="text-align: center">
		
							</div>
						</div>
					</div> -->

		
				</div>
				<div class="form-one" v-if="nowWeAre == 2">
					<div class="form-item" style="align-items: flex-start;">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								报价：
							</div>
		
							<div></div>
						</div>
						<div style="padding-top: 20px;">
							<el-radio-group v-model="serveData.price_type" @change='clearGDJG'>
								<el-radio :label="1" style="display: inline-block;">免费</el-radio>
								<el-radio :label="2" style="display: inline-block;">固定价格<input
										:disabled='serveData.price_type !== 2' v-model.number="serveData.price" type="text"
										style="width: 127px;height: 30px;border: 1px solid #D2D2D2;margin: 0px 10px;">元</el-radio>
								<el-radio :label="3">双方协商</el-radio>
							</el-radio-group>
						</div>
					</div>
					<div class="form-item" style="align-items: flex-start;">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								报价展示方式：
							</div>
		
							<div></div>
						</div>
						<div>
							<el-radio-group v-model="serveData.price_right">
								<div style="margin: 30px 0;"> <el-radio :label="1">完全公开</el-radio></div>
		
								<div style="margin: 30px 0;width: 500px;"> <el-radio :label="4">对以下用户公开</el-radio>
								</div>
		
							</el-radio-group>
							<!-- <el-transfer v-model="valuedw" :data="datadw">
								
								       <template v-slot:footer>
								         <el-pagination
								          
								           :page-sizes="[10, 20, 30, 40]"
								          
								           layout="prev, pager, next, sizes, total"
								         ></el-pagination>
										 </template>
							</el-transfer> -->
							<transferPage @removeChecked='getRemoveChecked' @leftToRight='getLeftToRight'></transferPage>
							<div style="text-align: center">
		
							</div>
						</div>
					</div>
					<div class="form-item" style="align-items: flex-start;">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								发布有效期：
							</div>
		
							<div></div>
						</div>
						<div style="padding-top: 20px;display: flex;">
							<el-select v-model="serveData.validity_type" placeholder="请选择">
								<el-option v-for="item in yxDateOptions" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<div class="block" style="margin-left: 50px;" v-show="serveData.validity_type == 2">
								<el-date-picker v-model="serveData.validity_datetime" :picker-options="shortcuts"
									type="datetime" value-format="timestamp" placeholder="设置过期时间">
								</el-date-picker>
							</div>
						</div>
					</div>
					<div class="form-item" style="align-items: flex-start;">
						<div style="display: flex;align-items: center;">
							<div class="jtitle">
								联系方式：
							</div>
		
							<div></div>
						</div>
						<div style="padding-top: 20px;display: flex;align-items:flex-end;justify-content: space-between;">
							<el-checkbox-group v-model="form2.contactRadio" @change='touchChange'>
								<div style="margin: 30px 0;"> <el-checkbox :label="'zhannei'">站内信息</el-checkbox></div>
								<div style="margin: 30px 0;"> <el-checkbox :label="'xuni'">使用虚拟电话</el-checkbox></div>
								<div style="margin: 30px 0;height: 50px;display: flex;align-items: center;">
									<div style="width: 120px;"><el-checkbox :label="'emali'">邮箱</el-checkbox></div>
									<input type="email" v-model="serveData.email"
										style="border: 1px solid #D2D2D2;;height: 38px;width: 280px;">
								</div>
								<div style="margin: 30px 0;height: 50px;display: flex;align-items: center;">
		
									<div style="width: 120px;"> <el-checkbox :label="'phone'">联系电话</el-checkbox></div>
									<input type="email" v-model="serveData.phone"
										style="border: 1px solid #D2D2D2;;height: 38px;width: 280px;">
		
								</div>
							</el-checkbox-group>
							<div>
								<div
									style="height: 50px;;display: flex;margin: 30px 0;align-items: center;padding-left: 80px;">
									验证码：<input type="text" v-model="serveData.email_captcha" placeholder="请输入验证码"
										style="border: 1px solid #D2D2D2;;height: 38px;width: 180px;">
									<p class="getCode" @click="send" v-if="showtime===null">获取邮箱验证码</p>
									<p v-else class="getCode"> {{showtime}}</p>
								</div>
								<div
									style="height: 50px;;display: flex;margin: 30px 0;align-items: center;padding-left: 80px;">
									验证码：<input type="text" v-model="serveData.phone_captcha" placeholder="请输入验证码"
										style="border: 1px solid #D2D2D2;;height: 38px;width: 180px;">
									<p class="getCode" @click="send2" v-if="showtime2===null">获取手机证码</p>
									<p v-else class="getCode"> {{showtime2}}</p>
								</div>
							</div>
						</div>
					</div>
		
				</div>
				<div v-if="nowWeAre == 3"> <el-result icon="success" title="提交成功,等待审核..." subTitle="">
						<template slot="extra">
						</template>
					</el-result>
					<p style="margin: auto;text-align: center;cursor: pointer;" class="gocheck"
						@click="$router.push(`/userCenter/pthd/projectNeed`)">去个人中心查看审核状态</p>
				</div>
				<div class="nextStep" v-if="nowWeAre == 1" @click="nextStep1">下一步</div>
				<div class="nextStep" v-if="nowWeAre == 2" @click="addProjectNeed">提交</div>
			</div>
			<div class="body-right">
				<div style="background: #0052D9;"   @click="$router.push('/userCenter/drafts')">
					<img src='../../assets/images/create.png' alt="" style="width: 18px;height: 18px;"><span
						style="width:100px">从草稿中创建</span>
				</div>
				<div style="background: #18BC9C;" @click="saveCaoGao">
					<img src='../../assets/images/caogao.png' alt="" style="width: 19px;height: 19px;">
					<span style="width:100px">保存至草稿箱</span>
				</div>

			
		
		
			</div>
		</div>
	</div>
</template>

<script>
	import isEmpty from '../../utils/isEmpty.js'
	import transferPage from '../../components/transferPage.vue'
	export default {
		name:"releaseNeed",
		data() {

			return {
				shortcuts: [{
					text: '今天',
					onClick(picker) {
						picker.$emit('pick', new Date());
					}
				}, ],
				type: '123',
				nowWeAre: 1,
				fileList1: [],
				autoGetImage: false,
				//资源分类 options 和 value
				xueKeOptions: [],
				hangYeOptions: [],
				jieDuanOptions: [],
				jieDuanValue: '',
				xueKeValue: '',
				hangYeValue: '',
				//项目模板
				zyTemplate: [],
				slTemplate: [],
				wzTemplate: [],
				//图集
				imageList: [],
				//被选中的图标
				checkedImage: '',
				//addtag
				companyInfo: [],
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				arrowStep: 1,
				radio: 3,
				valuedw: [1, 4],
				fileList2: [],
				form1: {
					twzy: '',
					zybt: '',
					zyfl: '',
					tjlue: '',
					keyword: [],
					xmxqsl: '',
					fwqx: 1,
					wzfiles: [],
					xmwzB: '',
					jmpwd: '',
					shuiyin: 1
				},
				//form2

				//有效日期
				yxDateOptions: [{
					value: 1,
					label: '长期有效'
				}, {
					value: 2,
					label: '短期有效'
				}],
				yxDateValue: '',

				//email
				timeCounter: null,
				// null 则显示按钮 秒数则显示读秒
				showtime: null,
				//phone
				timeCounter2: null,
				// null 则显示按钮 秒数则显示读秒
				showtime2: null,
				form2: {
					bjRadio: 'free',
					bjShowWay: 1,
					abelDate: '',
					contactRadio: ['zhannei'],
				},
				formFiles:[],
				serveData: {
					id: "",
					summary: "", //项目需求图文摘要
					title: "",
					subjectcate_id: null,
					industry_id: null,
					stage_id: null,
					image: "",
					tags: "",
					access_right: '',
					access_group: '', //用户组:1=注册用户,2=好友
					user_ids: "", //白名单
					price_type: 1,
					price: "",
					price_right: 1, //报价访问权限:1=完全公开,2=跟随缩略版权限,3=用户组,4=指定用户,5=双方协商 默认1
					price_group: null,
					validity_type: 1, //有效期类型:1=长期有效,2=限期有效
					validity_datetime: null, //有效期时间戳
					msg_status: 1, //站内信:0=禁止,1=启用 默认1
					email: "",
					email_status: '', //邮箱状态:0=禁止,1=启用
					email_captcha: '', //邮箱验证码
					phone: "",
					phone_status: 0,
					phone_captcha: '', //手机验证码
					phone_virtual: '', //虚拟电话	使用虚拟电话:0=否,1=是
					draft: 0, //草稿:0=不是,1=是 默认0
					price_user_ids: [],
					content:'',
				},
				renderedMarkdown1:'',
				renderedMarkdown2:'',
			}
		},
		components: {
			transferPage
		},
		created() {
			this.getXueKeList()
			this.getTemplateLists()
			this.getImageList()
			const release = [{
					id: '',
					first_id: '',
				},
				{
					id: '',
					first_id: '',
				},
			]
			this.$store.commit('init_releaseInfo', release)
		},
		watch: {
			'$store.state.releaseInfo': {
				handler(n, o) {
					this.serveData.summary = this.$store.state.releaseInfo[0].id
					this.serveData.content = this.$store.state.releaseInfo[1].id
					this.fetchMarkdownInfo(this.serveData.summary, 'renderedMarkdown1');
					this.fetchMarkdownInfo(this.serveData.content, 'renderedMarkdown2');
				},
				deep: true,
				immediate: true
			},

		},
		methods: {
			async deleteDrafts(type,id,a){
				
				let info 
				if(type == 1){
					info = await this.$api.getDraftProjectneedDel1({projectneed_id:id})
					// if(info.code == 1) this.Projectneed.data = this.Projectneed.data.filter(obj => obj.id !== id);
				}
				
				if(info.code == 1){
					this.$message({
						message:info.msg,
						 type: 'success'
					})
					if(a=='a1'){
						this.renderedMarkdown1 = '';
						this.serveData.summary = '';
					}
					if(a=='a2'){
						this.renderedMarkdown2 = '';
						this.serveData.content = '';
					}
				}else{
					this.$message({
						message:info.msg,
						 type: 'warning'
					})
				}
			},
			async fetchMarkdownInfo(id, targetProperty) {
			      try {  
			        const release = await this.$api.markdownGetInfo({ id:id});  
			        console.log('查询到的markdown详情', release);  
			        this[targetProperty] = release.data.title;  
			      } catch (error) {  
			        console.error('获取 Markdown 信息失败', error);  
			      }  
			},  
			async saveCaoGao(){
				this.serveData.draft = 1
				// this.serveData.project_need_files = this.serveData.project_need_files.join(',')
				const project = await this.$api.addHelpSolution({
					...this.serveData
				})
				if (project.code == 1) {
					this.$message({
						message: project.msg,
						type: 'success'
					})
					location.reload()
				} else {
					this.$message({
						message: project.msg,
						type: 'warning'
					})
				}
			},
			autoImage(e) {
				if (this.autoGetImage) {
					const randomIndex = Math.floor(Math.random() * this.imageList.length);
					this.serveData.image = this.imageList[randomIndex].image
				}
			},
			getRemoveChecked(e) {
				let ids = e.join(',')
				this.serveData.price_user_ids = ids 
			},
			getLeftToRight(e) {
				let ids = e.join(',')
				this.serveData.price_user_ids = ids 
			},
			async addProjectNeed() {
				if(!this.form2.contactRadio.length){
					this.$message({
						message: '请选择联系方式',
						type: 'warning'
					})
					return
				}
				this.serveData.draft = 0
				// this.serveData.project_need_files = this.serveData.project_need_files.join(',')
				if (this.serveData.price_right == 1) this.serveData.price_user_ids = []
				const project = await this.$api.addHelpSolution({
					...this.serveData
				})
				
				if (project.code == 1) {
					this.$message({
						message: project.msg,
						type: 'success'
					})
					this.nowWeAre = 3
					this.arrowStep = 3
				} else {
					this.$message({
						message: project.msg,
						type: 'warning'
					})
				}
			},
			touchChange(e) {
				const phone = e.includes('phone')
				const emali = e.includes('emali')
				const xuni = e.includes('xuni')
				const zhannei = e.includes('zhannei')
				console.log(phone, emali, xuni, zhannei);
				phone ? this.serveData.phone_status = 1 : this.serveData.phone_status = 0
				xuni ? this.serveData.phone_virtual = 1 : this.serveData.phone_virtual = 0
				zhannei ? this.serveData.msg_status = 1 : this.serveData.msg_status = 0
				emali ? this.serveData.email_status = 1 : this.serveData.email_status = 0
			},
			clearGDJG() {
				this.serveData.price = ''
			},
			chooseImage(item) {
				this.serveData.image = item.image
			},
			toMbDetail(id, index) {
				this.$router.push(`/editor?id=${id}&index=${index}`)
			},
			async getXueKeList() {
				const list = await this.$api.getLeftSubjectcateLists()
				this.xueKeOptions = list.data
				const hy = await this.$api.getHangYeLists()
				this.hangYeOptions = hy.data
				const jieDuan = await this.$api.getJieDuanLists()
				this.jieDuanOptions = jieDuan.data
			},
			async getTemplateLists() {
				const zy = await this.$api.templateLists({
					templatecate_id:23
				})
				this.zyTemplate = zy.data
				console.log(this.zyTemplate);
				const sl = await this.$api.templateLists({
					templatecate_id:24
				})
				this.slTemplate = sl.data
			},
			async getImageList() {
				const image = await this.$api.imageLists()
				this.imageList = image.data
				console.log(image.data);
			},
			countDownText(s) {
				this.showtime = `${s}s后重新获取`
			},
			verificationPwd() {
				if (this.serveData.summary === "" || this.serveData.title === "" || this.serveData.subjectcate_id === "" ||
					this.serveData.industry_id === "" || this.serveData.stage_id === "") {
					this.$message.error('请将带*信息填写完整');
					return false;
				}
				if (this.serveData.project_need_files != [] & this.serveData.password) {
					this.$message.error('请设置文件加密密码');
					return false;
				}
				return true
			},
			// 倒计时 60秒 不需要很精准
			countDown(times) {
				const self = this;
				// 时间间隔 1秒
				const interval = 1000;
				let count = 0;
				self.timeCounter = setTimeout(countDownStart, interval);

				function countDownStart() {
					if (self.timeCounter == null) {
						return false;
					}
					count++
					self.countDownText(times - count + 1);
					if (count > times) {
						clearTimeout(self.timeCounter)
						self.showtime = null;
					} else {
						self.timeCounter = setTimeout(countDownStart, interval)
					}
				}
			},
			async send() {
				const emailReg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/;
				if (!emailReg.test(this.serveData.email)) {
					this.$message({
						message: '邮箱格式错误',
						type: 'warning'
					})
				} else {
					const yzcode = await this.$api.sendEmailCode({
						event: 'form',
						email: this.serveData.email
					})
					if (yzcode.code == 1) {
						this.countDown(60);
						this.$message({
							message: yzcode.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: yzcode.msg,
							type: 'warning'
						})
					}

				}
			},
			countDownText2(s) {
				this.showtime2 = `${s}s后重新获取`
			},
			// 倒计时 60秒 不需要很精准
			countDown2(times) {
				const self = this;
				// 时间间隔 1秒
				const interval = 1000;
				let count = 0;
				self.timeCounter2 = setTimeout(countDownStart, interval);

				function countDownStart() {
					if (self.timeCounter2 == null) {
						return false;
					}
					count++
					self.countDownText2(times - count + 1);
					if (count > times) {
						clearTimeout(self.timeCounter2)
						self.showtime2 = null;
					} else {
						self.timeCounter2 = setTimeout(countDownStart, interval)
					}
				}
			},
			async send2() {
				const phoneReg = /^1\d{10}$/;
				if (!phoneReg.test(this.serveData.phone)) {
					this.$message({
						message: '手机号格式错误',
						type: 'warning'
					})
				} else {
					const email = await this.$api.sendPhoneCode({mobile:this.serveData.phone})
					if(email.code == 1){
						this.$message({
							message: email.msg,
							type: 'success'
						});
						this.countDown2(60);
					}
				}
			},

			asc() {
				console.log(this.type);
			},
			nextStep1() {

				if (this.verificationPwd()) {
					this.nowWeAre = 2
					this.arrowStep = 2
				}

			},
			submit() {

			},

			uploadSLT(e, a) {
				console.log(e.data.url);
				this.serveData.image = e.data.url
			},
			uploadWZB(e, file) {
				// const fileinfo = {name:file.name,url:file.response.data.url}
				console.log(file.response.data.url);
				this.formFiles.push(file.response.data.url)
				this.serveData.project_need_files = this.formFiles
			},
			chooseWzb(e) {
				this.form1.xmwzB = e
				this.$router.push('/editor')
			},
			chooseSl(e) {
				this.$router.push('/editor')
				this.form1.xmxqsl = e
			},
			//分类
			chooseFl(e) {
				this.serveData.subjectcate_id = e
			},
			//阶段
			chooseJD(e) {
				 
				this.serveData.stage_id = e
			}, //行业
			chooseHY(e) {
				this.serveData.industry_id =e
			},
			//选择摘要
			//addTag
			handleClose(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.dynamicTags.push(inputValue);
					this.serveData.tags = this.dynamicTags.join(',');
				}
				this.inputVisible = false;
				this.inputValue = '';
			}
		}
	}
</script>
<style>
	
	/* .el-radio__label {
		color: black;
	}

	.radio {
		position: relative;
		display: inline-block;
		margin-right: 12px;
	}

	.radio input {
		width: 15px;
		height: 15px;
		appearance: none;
		-webkit-appearance: none;
		opacity: 0;
		outline: none;
	}

	.radio label {
		position: absolute;
		left: 0;
		top: 6px;
		width: 15px;
		height: 15px;
		border: 1px solid #bcbcbc;
	}

	.el-radio__inner {
		border-radius: 0;
	}

	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	}
 */
	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}

	#taginp {
		height: 32px;
	}
</style>
<style scoped lang="less">
	.header {
		.backof{
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}
		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;
		&>div{
			&>img {
				width: 16px;
				height: 16px;
			}
			
			&>p {
				font-size: 16px;
				margin-left: 10px;
			
				&>span {
					color: #888888;
				}
			}
		}
	}
	.gocheck {
		&:hover {
			color: #0052D9;
		}
	}

	.activeImg {
		border: 1px solid #0052D9;
		padding: 3px;
		box-sizing: border-box;
		margin: 0 3px;
	}

	.tubiao {
		width: 100px;
		height: 100px;
		cursor: pointer;

		&>img {
			width: 100%;
			height: 100%;
		}

		&:hover {
			border: 1px solid #eee;
			padding: 3px;
			box-sizing: border-box;
			margin: 0 3px;
		}
	}

	.captcha-row {
		display: flex;

		.captcha-button {
			background: #048fff;
			color: white;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 4rpx 8rpx;
			width: 320rpx;
			border-radius: 4rpx;
		}
	}

	.getCode {
		width: 133px;
		height: 40px;
		background: #0052D9;
		border: 1px solid #D2D2D2;
		color: white;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	/deep/.el-input__inner {
		height: 46px;
		border: 1px solid #D2D2D2;
	}

	.nextStep {
		width: 261px;
		height: 40px;
		margin: 0 auto;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
		color: white;
		font-size: 18px;
		background: #0052D9;
	}

	.form-one {

		padding: 20px;
		padding-right: 40px;
		box-sizing: border-box;

		.form-item {
			.bottom {
				margin-top: 30px;
			}

			.inpt {
				width: 855px;
				height: 46px;
			}

			input[type=checkbox] {
				cursor: pointer;
				position: relative;
				width: 18px;
				height: 16px;
				font-size: 12px;
			}

			input[type=checkbox]::after {
				position: absolute;
				top: 0;
				color: #000;
				width: 18px;
				height: 16px;
				display: inline-block;
				visibility: visible;
				padding-left: 0px;
				text-align: center;
				content: ' ';
				border-radius: 3px
			}

			input[type=checkbox]:checked::after {
				content: "✓";
				color: #fff;
				font-size: 12px;
				font-weight: bold;
				background-color: #0052D9;
			}

			.jtitle {
				width: 140px;
			}

			.item-content {
				flex: 1;
				display: flex;
				overflow-x: auto;
				white-space: nowrap;

				.muban {
					margin-left: 50px;
					flex-shrink: 0;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 148px;
					height: 148px;
					background: #F6F6F6;
					cursor: pointer;

					&>div {
						display: flex;
						justify-content: center;
						flex-wrap: wrap;
					}

					p {
						width: 100%;
						text-align: center;
						margin-top: 10px;
					}

					&:first-child {
						margin-left: 0;
					}

				}

				.muban:hover {
					background: #e3e3e3;
				}
			}

			display: flex;
			flex-wrap: wrap;
			width: 100%;
			margin: 20px 0 40px 0;
		}

		.laterUp {
			display: flex;
			align-items: center;


		}
	}

	.box,
	.box-f,
	.box-l {
		position: relative;
		/* 设置元素定位的基准 */
		width: 270px;
		height: 48px;
		background-color: #F6F6F6;
		margin-left: 24px;
		text-align: center;
		line-height: 48px;
		font-size: 18px;
	}

	/* 设置前面板（上半部分） */
	.box::before,
	.box-f::before {
		content: '';
		position: absolute;
		/* 相对于父元素进行绝对定位 */
		right: 0;
		transform: translateX(100%) rotate(90deg);
		/* 旋转45度 */
		width: 0;
		/* 去掉宽度 */
		height: 0;
		/* 去掉高度 */
		border-width: 24px;
		border-style: solid;
		border-color: transparent transparent #F6F6F6 transparent;
	}

	.box::after,
	.box-l::after {
		content: '';
		position: absolute;
		/* 相对于父元素进行绝对定位 */
		left: 0;
		transform: rotate(90deg);
		/* 旋转45度 */
		width: 0;
		/* 去掉宽度 */
		height: 0;
		/* 去掉高度 */
		border-width: 24px;
		border-style: solid;
		border-color: transparent transparent white transparent;
	}

	.box-active,
	{
	background: #0052D9;
	color: white;
	}

	.box-active::before {
		border-color: transparent transparent #0052D9 transparent;
	}

	/* 设置后面板（下半部分） */

	.left {
		padding: 25px 0;
		box-sizing: border-box;
		width: 1180px;
		margin-bottom: 50px;
		background: #FFFFFF;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50px;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}
	.m1 {
	  /* 设置一个固定的宽度，或者根据布局需要调整 */
	  width: 200px; /* 示例宽度，你可以根据需要调整 */
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  /* 可选：添加一些内边距或外边距 */
	  padding: 10px;
	  box-sizing: border-box;
	}
	.m2 {
		/* 确保文本在达到容器宽度时自动换行 */
		word-wrap: break-word;
		overflow-wrap: break-word; /* 这是一个更现代的属性名，与word-wrap等效 */
		white-space: normal; /* 默认值，但明确设置可以避免潜在的CSS继承问题 */
		text-align: center; /* 可选：根据需要将文本居中 */
		/* 可选：添加一些上边距或下边距 */
		margin-top: 5px;
	}
</style>